__turbopack_context__.v({
  "animation": "LoadingIndicator-module__Ll6loG__animation",
  "container": "LoadingIndicator-module__Ll6loG__container",
  "fishSwim": "LoadingIndicator-module__Ll6loG__fishSwim",
  "image": "LoadingIndicator-module__Ll6loG__image",
  "main": "LoadingIndicator-module__Ll6loG__main",
});
